/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 480);
/******/ })
/************************************************************************/
/******/ ({

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$(document).ready(function () {
	var field = $('.prayer-selection select');

	$(field).change(function () {

		var prayerTextarea = $('.prayer-message textarea');
		var prayer = ' ';

		if ($('select').val() == 'custom') {
			prayer = 'Enter your custom prayer here...';
			$(prayerTextarea).val(prayer);
		}

		if ($('select').val() == 'world-peace') {
			prayer = 'Loving Jesus,\nOur Light and our Joy\nLighting our way on the\nJourney of life\nCome to us, Jesus,\nBe hope for the weary,\nThe young and uncertain\nThe lonely and lost\nEnkindle within us your\nHope’s bright fire\nHelp us to be candles of Hope\nIn the dark of our World\n-Sister Noel Devine, M.M.';
			$(prayerTextarea).val(prayer);
		}

		if ($('select').val() == 'myself') {
			prayer = 'The fact that I am\nIs amazing and wonderful…\nI can move about,\nI can think, love, and choose.\nI can grow-\nIn wisdom.\nI am yours, God.\nYour beloved child.\nGifted as you see fit,\nFor sharing,\nFor loving,\nFor bearing.\nIn utter reliance on You;\nIn trust,\nTotally secure,\nTotally loved,\nTotally yours.\n-Sister Virginia Flagg, M.M.';
			$(prayerTextarea).val(prayer);
		}

		if ($('select').val() == 'sympathy') {
			prayer = 'I am the resurrection\nAnd the life.\nThose who believe in me,\nEven though they die,\nWill live, and everyone\nWho lives and believes\nIn me will never die..';
			$(prayerTextarea).val(prayer);
		}

		if ($('select').val() == 'the-poor') {
			prayer = 'God of Justice,\nopen our eyes\nto see you in the face of the poor.\nOpen our ears\nto hear you in the cries of the exploited.\nOpen our mouths\nto defend you in the public squares\nas well as in private deeds.\nRemind us that what we do\nto the least ones,\nwe do to you.\nAmen.';
			$(prayerTextarea).val(prayer);
		}

		if ($('select').val() == 'the-sick') {
			prayer = 'May you be wrapped up in God’s love,\nFound deep in His everlasting wings,\nCarried and kept, safe and cherished.\nMay the healing power of Christ\nBreathe across your being now.';
			$(prayerTextarea).val(prayer);
		}

		if ($('select').val() == 'the-hungry') {
			prayer = 'Loving God,\nwe ask for Your blessings on children, mothers, fathers, and communities\nwho are thirsty.\nPurify, protect, and multiply\ntheir water sources.\nStrengthen their resolve so they may fully enjoy\nthe benefits of clean water —\nessentials like education,\ngardens of fresh produce,\nand good health.';
			$(prayerTextarea).val(prayer);
		}

		if ($('select').val() == 'youre-my-only-hope') {
			prayer = 'Loving and compassionate God,\nSend us your gift of hope, we pray.\nLike the flowers of spring,\nhope brings new life and joy.\nSend the bright spirit of hope\nto our hurting world.\nWhen we are lonely and afraid,\nweary and discouraged,\nsend us hope.\nMay we live each day\nin joyful hope.\nWe ask this through Mary,\nthe Mother of Hope\n-Sr. Noel Devine M.M.';
			$(prayerTextarea).val(prayer);
		}

		if ($('select').val() == 'sisters') {
			prayer = 'O God of the Resurrection,\nin the silence and prayer of our hearts,\nwe hold our Maryknoll Sisters who have gone before us!\nThey have reached a fullness\nfor more than this life could give,\nand are now embraced totally by Your Love!\n\nEach person, O Holy One,\nis Your Love Song\nthat goes on singing forever,\nand each one’s melody continues\nto live on in all of us ~ and beyond!\nThrough Jesus, the Christ, Amen!';
			$(prayerTextarea).val(prayer);
		}

		if ($('select').val() == 'loved-one') {
			prayer = 'With grace and spontaneity,\nthe beautiful spirits of our loved ones\nhave taken wing,\nand though the body has left our sight,\nwe hold forever\ntheir sacred presence in our hearts!';
			$(prayerTextarea).val(prayer);
		}

		if ($('select').val() == null) {
			prayer = ' ';
			$(prayerTextarea).reset();
		}
	});
});

$(document).ready(function () {
	$('a.pop').click(function () {
		window.open($(this).attr('href'), 'popupWindow', 'width=600, height=400, scrollbars=yes');
	});
});

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.light-a-candle.js